import * as z from "@-/com.npmjs.zod";

export const morphemeGraphemeMorphemeSliceSchema = z.object({
  grapheme: z.string(),
  strokeCount: z.int().nullish(),
});
